export default {
  recentlyViewed: {
    emptyTitleFiltered: '沒有符合的項目',
    emptyHintFiltered: '與我共用中沒有符合搜尋條件的項目。',
    tab: '與我共用',
    remove: '從與我共用中移除',
    emptyTitle: '尚無項目',
    emptyHint: '其他人與你分享的項目，開啟後會顯示在這裡。',
  },
  betaBadge: {
    label: 'Beta',
  },
  controls: {
    sortAriaLabel: '排序',
    sortAscTooltip: '遞增排序 — 點擊改為遞減',
    sortDescTooltip: '遞減排序 — 點擊改為遞增',
    sortAscAriaLabel: '目前為遞增排序，點擊切換為遞減',
    sortDescAriaLabel: '目前為遞減排序，點擊切換為遞增',
    gridViewAriaLabel: '格狀檢視',
    listViewAriaLabel: '清單檢視',
  },
  loadMore: {
    loading: '載入中…',
  },
  uploadZone: {
    rejectTooLarge: '檔案太大。檔案大小上限為 {{maxGb}} GB。',
    rejectInvalidType: '檔案類型無效。僅接受 {{types}} 檔案。',
    rejectGeneric: '無法上傳檔案。',
    uploading: '上傳中…',
    repairTooltip:
      '在生成網格前先診斷並修復 CAD — 修補縫隙、非流形邊與異常面。此為預設選項。',
    wrapTooltip:
      '以乾淨的水密表面包覆零件後再對其生成網格 — 對於髒亂或有洩漏的 CAD 更為穩健。最適合用來確認零件是否能夠成功生成網格；各面的邊界標籤尚未一併保留。支援外部流動、內部流動與共軛熱傳（CHT），且匯入後即固定 — 若需要 FEA，或需要為個別實體命名，請選擇「修復」。',
    repair: '修復',
    wrap: '包覆',
    browseFiles: '瀏覽檔案',
    fileInputLabel: '選擇要上傳的 CAD 檔案',
  },
  uploadPrep: {
    title: '選擇幾何前處理',
    description: '在網格化之前，要如何準備 {{file}}？匯入後即固定。',
    cancel: '取消',
    confirm: '匯入',
  },
  aiActivity: {
    tab: 'AI 活動',
    chipNeedsYou_one: '需要你確認',
    chipNeedsYou_other: '{{count}} 項需要你確認',
    chipNeedsYouHint_one: 'AI 已備妥修正方案，正在等你確認。',
    chipNeedsYouHint_other: 'AI 已備妥 {{count}} 項修正方案，正在等你確認。',
    chipRetrying_one: 'AI 正在重試',
    chipRetrying_other: '{{count}} 項正在重試',
    chipRetryingHint_one: '因為失敗了，AI 已調整設定並重新執行。',
    chipRetryingHint_other: 'AI 已調整設定，正在重新執行 {{count}} 項。',
    chipFixed_one: '已修正 1 項',
    chipFixed_other: '已修正 {{count}} 項',
    chipFixedHint_one: '失敗之後，AI 讓它順利完成了。',
    chipFixedHint_other: '失敗之後，AI 讓其中 {{count}} 項順利完成了。',
    filterContext_one: '顯示 {{total}} 項中的 1 項 — AI 處理過的項目',
    filterContext_other: '顯示 {{total}} 項中的 {{count}} 項 — AI 處理過的項目',
    filterEmptyTitle: 'AI 沒有需要你處理的事',
    filterEmptyHint:
      '沒有需要你確認的項目，AI 在過去 {{days}} 天也沒有修正任何項目。',
    clearFilter: '清除篩選',
    columnHeader: 'AI',
  },
} as const;
